


















































































import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import { Emit, Watch } from "vue-property-decorator";

import CommunicationEmailNotification from "@/components/headers/communication-email-notifications";

import Header from "@/types/app/header";
import Notification, {
  notificationInitialValue,
} from "@/types/app/notifications";

import formatMoney from "@/utils/formatMoney";
import applyCondition from "@/utils/applyCondition";
import formatDate from "@/utils/formatDate";
import { truncate } from "@/utils/truncate";
import Endpoint from "@/utils/endpoint";
import { getNotifications } from "@/utils/getNotifications";
import ModalDeleteNotification from '@/components/common/ModalDeleteNotification.vue';
import ErrorService from "@/services/erroService";
import BaseComponent from "@/utils/baseComponent";
import AccountService from "@/services/accountService";

const namespace = "communication";

@Component({
  components: {
  },
  methods: {
    formatMoney,
    formatDate,
    truncate,
  }
})
export default class NotificationByEmail extends BaseComponent {


 
 
  private endpoint = new Endpoint();

  loadingNotifications = false;
  headers: Header[] = CommunicationEmailNotification.header;
  emailNotifications: Notification[] = [];
  selectedNotifications: any[] = [];
  openSuccessModal = false;
  openSuccessModalMessage = '';
  titleFilter = "";
  descriptionFilter = "";
  hasAppUrlFilter = "";



  get hasSelectedNotifications() {
    return this.selectedNotifications.length > 0;
  }

  async mounted() {
    await this.handleNotifications();
  }

  async handleNotifications() {
    this.loadingNotifications = true;
    this.emailNotifications = await getNotifications(`${this.endpoint.notifications}/getbygrid`, 'Email', this.$http);
    this.loadingNotifications = false;
  }

  
  get filteredNotifications() {
    const conditions: any[] = [];
    if (this.titleFilter) {
      conditions.push((item: Notification) => item.title.toLowerCase().includes(this.titleFilter.toLowerCase()));
    }

    if (this.descriptionFilter) {
      conditions.push((item: Notification) => item.description.toLowerCase().includes(this.descriptionFilter.toLowerCase()));
    }

    if (this.hasAppUrlFilter) {
      conditions.push((item: Notification) => item.hasAppUrl.toString().toLowerCase().includes(this.hasAppUrlFilter.toLowerCase()));
    }
    return applyCondition<Notification>(this.emailNotifications, conditions);
  }
  getUrlTransform(url: string): string {
    return url.replace('{0}', '#ClientId#');
  }

  deleteNotifications() {
    this.$confirm('Do you really want to delete this select notification(s)?').then(
      (res) => {
        if (res) {
          const url = `${this.endpoint.notifications}`;
          const notificationIds = this.selectedNotifications.map((x) => x.id);
          this.loadingNotifications = true;
          this.$http
            .delete(`${url}`, { data: { notificationIds } })
            .then((res: any) => {

              this.emailNotifications = this.emailNotifications.filter(p => !notificationIds.some(m => m == p.id));

              this.showSuccess('Deleted notification(s) with success!');
              this.selectedNotifications = [];
              this.loadingNotifications = false;
            })
            .catch((error: any) => {
              this.loadingNotifications = false;
              ErrorService.onError({ status: -1, message: 'Notifications:deletedNotifications', error });
            });
        }
      }
    );
  }

  showNotification(notification: Notification) {
    this.$router.replace({
      name: 'NotificationEmailView',
      params: { notificationId: notification.id}
    });
  }

  showNewNotificationModal() {
    this.$router.push({ name: "NotificationEmailCreate" });
  }
}
